module.exports = __webpack_public_path__ + "static/media/expand.2093d9ce.svg";